import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/program/front/git/cloud_space_manage_front/node_modules/_@babel_runtime-corejs2@7.24.0@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { login as _login, loginByTicket as _loginByTicket, logout as _logout, getInfo as _getInfo, getMenu as _getMenu } from '@/api/user';
import { getToken, setToken, removeToken, getPhone, setPhone, removePhone, setUserId, getUserId, setSchoolId, getSchoolId, setAccountType, getAccountType } from '@/utils/auth';
import { resetRouter } from '@/router';
var state = {
  token: getToken(),
  phone: getPhone(),
  userid: getUserId(),
  name: '',
  school_id: getSchoolId(),
  school_name: '',
  avatar: '',
  roles: '',
  account_type: getAccountType()
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_ACCOUNT_TYPE: function SET_ACCOUNT_TYPE(state, account_type) {
    state.account_type = account_type;
  },
  SET_PHONE: function SET_PHONE(state, phone) {
    state.phone = phone;
  },
  SET_USERID: function SET_USERID(state, userid) {
    state.userid = userid;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_SCHOOL_NAME: function SET_SCHOOL_NAME(state, school_name) {
    state.school_name = school_name;
  },
  SET_SCHOOL_ID: function SET_SCHOOL_ID(state, school_id) {
    state.school_id = school_id;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLE: function SET_ROLE(state, roles) {
    state.roles = roles;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var phone = userInfo.phone,
      password = userInfo.password;
    commit('SET_PHONE', phone);
    setPhone(phone);
    return new Promise(function (resolve, reject) {
      _login({
        phone: phone.trim(),
        password: password,
        source: 303
      }).then(function (response) {
        var data = response.data;
        commit('SET_USERID', data.user_id);
        commit('SET_TOKEN', data.token);
        commit('SET_ACCOUNT_TYPE', data.account_type);
        commit('SET_SCHOOL_ID', data.school_id);
        setToken(data.token);
        setUserId(data.user_id);
        setAccountType(data.account_type);
        window.sessionStorage.setItem('account_type', data.account_type);
        setSchoolId(data.school_id);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loginByTicket: function loginByTicket(_ref2, userInfo) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      _loginByTicket(_objectSpread(_objectSpread({}, userInfo), {}, {
        source: 303
      })).then(function (response) {
        var data = response.data;
        if (data.user_id) {
          commit('SET_USERID', data.user_id);
          commit('SET_TOKEN', data.token);
          commit('SET_ACCOUNT_TYPE', data.account_type);
          commit('SET_SCHOOL_ID', data.school_id);
          setToken(data.token);
          setUserId(data.user_id);
          setAccountType(data.account_type);
          window.sessionStorage.setItem('account_type', data.account_type);
          setSchoolId(data.school_id);
          resolve();
        } else {
          reject({
            msg: "自动登录失败，请输入账号密码登录！"
          });
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      _getInfo(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var user_name = data.user_name,
          school_name = data.school_name,
          school_id = data.school_id,
          user_id = data.user_id;
        commit('SET_NAME', user_name || 'guest');
        commit('SET_USERID', user_id);
        commit('SET_SCHOOL_NAME', school_name);
        commit('SET_SCHOOL_ID', school_id);
        commit('SET_ACCOUNT_TYPE', data.account_type);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getMenu: function getMenu(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      _getMenu(state.token).then(function (response) {
        var data = response.data,
          list = response.list;
        if (list.length === 0) {
          reject('Verification failed, please Login again.');
        }
        var roles = [];
        var _iterator = _createForOfIteratorHelper(list),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            roles.push(item.path);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        commit('SET_ROLE', roles);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_PHONE', '');
        commit('SET_ROLE', '');
        commit('SET_NAME', '');
        commit('SET_SCHOOL_NAME', '');
        sessionStorage.removeItem("hasGetUserInfo");
        removeToken();
        removePhone();
        resetRouter();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_PHONE', '');
      removeToken();
      removePhone();
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};